<template>
    <div class="container">
    
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-10">

                <div class="panel">
                    <div class="panel-header">
                        <div class="row">
                            <div class="col-lg-6 col-md-6" style="padding-top:7px;">
                                Adicionar engenheiro
                            </div>
                            <div class="col-lg-6 col-md-6 right">
                                
                            </div>
                        </div>
                    </div>
                    <div class="panel-content">
                        
                        <p><strong>Informações gerais</strong></p>
                        <div class="row" style="margin-bottom:25px;">
                            <div class="col-lg-6 col-md-6">
                                <label>Nome</label>
                                <input type="text" class="form-control" v-model="eng.nome">
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <label>CPF</label>
                                <input type="text" class="form-control" v-model="eng.cpf" v-mask="'###.###.###-##'">
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <label>CREA</label>
                                <input type="text" class="form-control" v-model="eng.crea">
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <label>RNP</label>
                                <input type="text" class="form-control" v-model="eng.rnp">
                            </div>
                        </div>

                        <p><strong>Informações de contato</strong></p>
                        <div class="row" style="margin-bottom:25px;">
                            <div class="col-lg-6 col-md-6">
                                <label>Telefone</label>
                                <input type="text" class="form-control" v-model="eng.telefone">
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <label>Celular</label>
                                <input type="text" class="form-control" v-model="eng.celular" v-mask="'(##) ####-#####'">
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <label>E-mail</label>
                                <input type="text" class="form-control" v-model="eng.email">
                            </div>
                        </div>
                        
                        <p><strong>Endereço</strong></p>
                        <div class="row">
                            <div class="col-lg-4 col-md-4">
                                <label>CEP</label>
                                <the-mask type="text" :mask="['#####-###']" @keyup.native="Cep(eng.cep)" v-model="eng.cep" class="form-control" ref="numero" />
                            </div>
                            <div class="col-lg-8 col-md-8">
                                <label>Logradouro</label>
                                <input type="text" class="form-control" v-model="eng.logradouro">
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <label>Número</label>
                                <input type="text" class="form-control" v-model="eng.numero">
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <label>Complemento</label>
                                <input type="text" class="form-control" v-model="eng.complemento">
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <label>Bairro</label>
                                <input type="text" class="form-control" v-model="eng.bairro">
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <label>Cidade</label>
                                <input type="text" class="form-control" v-model="eng.cidade">
                            </div>
                            <div class="col-lg-2 col-md-2">
                                <label>UF</label>
                                <input type="text" class="form-control" v-model="eng.uf">
                            </div>
                        </div>

                    </div>
                    <div class="panel-footer">
                        <button class="btn btn-secondary" style="margin-right:15px;">Cancelar</button>
                        <button class="btn btn-success" @click="SalvarEng()">Salvar engenheiro</button>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue'
import config from '@/config'

export default {
    name:"NovoEngenheiro",
    data(){
        return{
            config:config,
            eng:{
                logradouro:'',
                bairro:'',
                cidade:'',
                uf:'',
            }
        }
    },
    methods:{

        Error(val){
            Vue.toasted.show(val, { 
                theme: "toasted-primary", 
                position: "top-right", 
                duration : 5000
            });
        },

        Cep(cep){
            if(cep.length>7){
                this.$http
                .get("https://viacep.com.br/ws/"+cep+"/json/")
                .then((result) => {
                    if(result.status==200){
                        this.eng.logradouro = result.data.logradouro;
                        this.eng.bairro = result.data.bairro;
                        this.eng.cidade = result.data.localidade;
                        this.eng.uf = result.data.uf;
                    }
                });
            }
        },
        SalvarEng(){
            this.$http.post(this.config.API+'engs/criar',this.eng)
            .then(response => {
                console.log(response)
                if(response.data.error==true){
                    for (let value of Object.values(response.data.message)) {
                        this.Error(value)
                    }
                }else{
                    this.Error('Engenheiro cadastrado com sucesso!')
                }
            })
        }

    }
}
</script>

<style scoped>
    
</style>